(() => {
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-card-add-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;

    const button = form.querySelector('[data-card-submit]');
    const status = form.closest('.product-card').querySelector('[data-card-status]');
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.hidden = true;

    try {
      const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { open: true } }));
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
      status.hidden = false;
    } finally {
      button.disabled = false;
      form.removeAttribute('aria-busy');
      delete form.dataset.pending;
    }
  });
})();
